/**
 * created by yxxyyxyx
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Input, Tabs,Checkbox } from 'antd';
import TableComponents from "../../components/TableComponents";
import BaseComponent from "../../../../base/BaseComponent";
import {TitleIcon} from "../../../components/customTable/CustomTable";
import Btn from "../../components/btn/Btn";
import {formatDate} from '../../../../utils'
import request from "../../../../base/request";
import {setInfoToLocalStorage} from "../../../../actions";

const { TabPane } = Tabs;
const {Search} = Input;
export default class SolicitationChoose extends BaseComponent {
    static defaultProps = {};
    static propTypes = {

    };

    constructor(props) {
        super(props);
        this.state = {
            activeKey:"全部",
            record:{},
            searchText:'',
            dataSource:[],
            start:1,
            size:10,
            count:0,
            selectedPerson:[],
            allCheck:false
        }
    }

    componentWillMount() {
    }
    sysConfigLoadOver() {

       let record =this.props.record;
        if(record){
            this.state.selectedPerson = record;
            this.setState({})
        }
            this.getList();


    }
    componentDidMount() {
    }

    customRender() {
        return (
            <div>
                {this.renderBtnList()}
                {this.renderData()}

            </div>
        )
    }
    renderBtnList(){
        let searchObj = this.sysConfig.searchObj||null;
        if(searchObj) {
            return (
                <div style={{display:'flex',justifyContent:"space-between",padding:'0px 20px'}}>
                    <div>
                        {searchObj&&searchObj.expression?<Search placeholder={searchObj.placeholder}  value={this.state.searchText}
                                                                 onChange={(e) => {
                                                                     this.setState({searchText: e.target.value},()=>{
                                                                         this.getList();
                                                                     })
                                                                 }} onSearch={(v) => this.onSearch(v)}
                                                                 style={{width: "200px"}}/>:''}
                    </div>
                </div>

            )
        }else {
            return null
        }
    }
    //顶部搜索
    onSearch(v) {
        this.setState({searchText:v,start:1},()=>{
            this.getList()
        });
    }
    //选人数据
    renderData(){
        let columns =this.sysConfig.columns||[];
        let data =this.state.dataSource;
        let btnList = this.sysConfig.btnList||[];
        let newColumns=[];
        columns&&columns.length&&columns.forEach((item,index)=>{

                  if(item.key==='deptNames' ){
                          newColumns.push({
                              title: item.title,
                              sorter: (a, b) => a.deptNames - b.deptNames,
                              key: item.key,
                              render: (text, record, index) => {
                                  let data = text.deptList;
                                  let newData =[]
                                  data.forEach((item)=>{
                                      newData.push(item.name)
                                  });
                                  return (
                                       <div>{(newData.join(','))}</div>
                                  )
                              }
                })
            }else if(item.key ==='index'){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    render: (text, record, index) => {
                        return (
                            <div>{
                                this.state.start===1?<div>{index+1}</div>:<div>{(index+1)+(this.state.start-1)*this.state.size}</div>
                            }</div>
                        )
                    }
                })
            }else if(item.key ==='check'){
                      newColumns.push({
                          title: <div> <Checkbox checked={this.state.allCheck}  onChange={(e)=>{this.allCheck(e)
                          }}></Checkbox></div>,
                          key: item.key,
                          width:'100px',
                          render: (text, record, index) => {
                              return (
                                  <div >{
                                      <Checkbox checked={record.checked} onChange={(record)=>{this.changeCheck(text,index)
                                     }}></Checkbox>
                                  }</div>
                              )
                          }
                      })
                  }
            else{
                newColumns.push(item)
            }
        });
        return(
            <div style={{marginTop:'10px'}}>
                {this.sysConfig&&<TableComponents btnList={btnList}
                                                  dataSource={data}
                                                  columns={newColumns}
                                                  selections={true}
                                                  start={this.state.start}
                                                  size={this.state.size}
                                                  count={this.state.count}
                                                  onChange={(page, pageSize)=>{
                                                      this.state.start = page
                                                      this.state.size =pageSize
                                                      this.setState({},()=>{
                                                          this.getList()
                                                      })
                                                  }}
                ></TableComponents>}
            </div>
        )
    }
    allCheck(e){
        let isCkeck =  e.target.checked;
            this.state.dataSource.forEach((item)=>{
                if(isCkeck){
                    this.state.selectedPerson.push(item);
                    item.checked=true
                }else{
                    item.checked=false
                    // this.state.selectedPerson = this.state.selectedPerson.filter(item=>item.id !==e.id )
                }
            });
        this.setState({allCheck:isCkeck});
        this.setState({})
    }
    changeCheck(items){

        items.checked = !items.checked;
        let num= 0;
        this.setState({});
        if(items.checked){
            this.state.selectedPerson.push(items);
            this.state.dataSource.forEach((item)=>{
                 if(item.checked){
                     num++
                 }
            });
            if(num === this.state.dataSource.length){
                this.state.allCheck=true
            }
        }else{
            this.state.allCheck=false;
            this.state.selectedPerson.forEach((item)=>{
                console.log(item)
               if(item.reporterId){
                   this.state.selectedPerson = this.state.selectedPerson.filter(item=>item.reporterId !==items.id )
               }else {
                   this.state.selectedPerson = this.state.selectedPerson.filter(item=>item.id !==items.id )
               }
            })


        }
       this.setState({},()=>{
             console.log( this.state.selectedPerson)
       })
    }
    getList() {
        let body = {};
        let params = [];
        let requestInformation = this.sysConfig.requestInformation || "";
        let listUrl = requestInformation.listUrl  || "";
        let requestMethod = requestInformation.requestMethod  || "post";
        let storyTypeKey = requestInformation.requestShowRefKey  || "showRef";
        let storyTypeVal = requestInformation.requestShowRefVal  ;
        let smallTabParam = requestInformation.smallTabParam.key ;

        let requestStartParam = requestInformation.requestStartParam  || "page";
        let requestSizeParam = requestInformation.requestSizeParam  || "size";
        let requestRoleCodeParam = requestInformation.requestRoleCodeParam  || "roleOption";
        body[requestStartParam] = this.state.start;
        body[requestSizeParam] = this.state.size;
        body[requestRoleCodeParam] =['rr'];
        if(this.state.searchText){
            body[smallTabParam] =  this.state.searchText;
        }
        body[storyTypeKey] = storyTypeVal;
        request({url:listUrl, contentType:"json", body,  method:requestMethod, callBack:(data)=>{
                this.setState({dataSource:data.data,count:data.count},()=>{
                    if( this.state.selectedPerson&& this.state.selectedPerson.length){
                        let num=0;
                        this.state.dataSource.forEach((item,index)=>{
                            this.state.selectedPerson.forEach((i,ids)=>{
                                if(i.id === item.id ||i.reporterId === item.id ){
                                    num++;
                                    item.checked =true
                                }
                            })
                            if(num === this.state.dataSource.length){
                                this.state.allCheck=true
                            }else{
                                this.state.allCheck=false
                            }
                        })
                    }
                     this.setState({})
                })
            }});
    }
    onOk=()=>{
            this.complete( this.state.selectedPerson);
    }





}
